import { render, staticRenderFns } from "./downLoad-item.vue?vue&type=template&id=3ace098f";
import script from "./downLoad-item.vue?vue&type=script&lang=js";
export * from "./downLoad-item.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;